import { FormikHelpers } from "formik";
import { useCreateOtellConType } from "./api/createOtellConType";
import OtellConTypeForm from "./OtellConTypeForm";


const CreateOtellConType = ({handleCloseModal}: CreateOtellConTypeProps)  => {
  const createOtellConTypeMutation = useCreateOtellConType({data: {}});

  const initialValues: IPostNewOtellConType = {
    description: "",
    deleted: false
  };

  const handleSubmit = async (values: IPostNewOtellConType, { setSubmitting }: FormikHelpers<IPostNewOtellConType>): Promise<void> => {
    try {
      await createOtellConTypeMutation.mutateAsync({
        data: values,
      });
      handleCloseModal();
    } catch (error) {
      console.log(error);
      console.log("values", values);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <OtellConTypeForm initialValues={initialValues} type="create" onSubmit={handleSubmit} />
  )
}

interface CreateOtellConTypeProps {
  handleCloseModal: () => void;
}

export default CreateOtellConType;